import { Fragment } from 'react';
export const style = "szdyjr3";
export const InfoList: React.FC<{
  data: {
    title: React.ReactNode;
    value: React.ReactNode;
  }[];
}> = props => {
  return <dl className={style}>
      {props.data.map((row, i) => {
      return <Fragment key={i}>
            <dt className="py-4 whitespace-pre-wrap">{row.title}</dt>
            <dd className="py-4 whitespace-pre-wrap">{row.value}</dd>
          </Fragment>;
    })}
    </dl>;
};

require("./InfoList.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./InfoList.tsx");